import { Injectable } from '@angular/core';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProductivityService {
  // tslint:disable-next-line:typedef
  baseUrl: string = Constants.CORE_API_BASE_URL;
  O3CoreApiUrl: string = Constants.CORE_API_BASE_URL;
  constructor(private http: HttpClient) { }

  getOEE(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Dashboard/GetOEEDashboard', data);
  }

  getOEEFromSnowflakes(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Dashboard/GetOEEDashboardfromSnowflakes', data);
  }

  getOEECore(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Dashboard_Core/GetOEEDashboard', data);
  }

  getMaintenance(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Dashboard/GetMaintenanceDashboard', data);
  }

  getProductionQualityData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Dashboard/GetOEEDashboard', data);
  }
  getProductionQualityDataCore(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Dashboard_Core/GetOEEDashboard', data);
  }
  getProductionShiftData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetShiftDetailsByUnit', data);
  }

  getGroupData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Dashboard_Core/GetEnterpriseList', data);
  }

  getPlantsData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Dashboard_Core/GetPlantList', data);
  }

  getLineData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Dashboard_Core/GetLineList', data);
  }
  getLineDataCore(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Dashboard_Core/GetLineList', data);
  }
  getUnitDataByMultipleLines(data: any): Observable<any[]> {
    // return this.http.post<any[]>(this.baseUrl + 'Dashboard/GetUnitList', data);
    return this.http.post<any[]>(this.baseUrl + 'Dashboard/GetUnitListByMultipleLine', data);
  }

  getLineByDeptData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Dashboard/GetLineListByDept', data);
  }

  getUnitData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Dashboard/GetUnitList', data);
  }
  getUnitDataCore(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Dashboard_Core/GetUnitList', data);
  }

  getComponentData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Dashboard/GetComponentList', data);
  }

  getUOMData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Planner/GetUOM', data);
  }

  submitProductionPlan(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Planner/SubmitProductionPlan', data);
  }

  getProductionPlanDetail(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Planner/GetProductionPlanDetail', data);
  }

  getProducts(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Planner/GetProducts', data);
  }

  submitProductionPlanDetail(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Planner/SubmitProductionPlanDetail', data);
  }

  getOEEANDAPQ(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Dashboard/GetDailyOEEANDAPQDashboard', data);
  }

  GetAdminInfoDashboard(data: any): Observable<any[]> {

    return this.http.post<any[]>(this.baseUrl + 'Dashboard/GetAdminInfoDashboard', data);

  }

  GetEnergyDashboard(data: any): Observable<any[]> {

    return this.http.post<any[]>(this.baseUrl + 'Dashboard/GetEnergyDashboard', data);

  }
  getVariableGroup(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Variable/GetVariableGroupList', data);
  }

  getVariableGroupParametrs(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Variable/getVariableGroupVariables', data);
  }

  getParameterAnalysisDashboard(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Dashboard/GetParameterAnalysisDashboard', data);
  }

  //======================== Downtime Pareto Dashboard===============================================//
  getDTParetoDashboard(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'ParetoAnalysis/GetParetoDashboard', data);
  }
  getFaultList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'ParetoAnalysis/GetFaultDurationDetails', data);
  }
  //==============================MOngoDB service=======================================//
  getDashboardDataMongo(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Mongodb/GetTagValues',data);
  }

  manageUnit(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Mongodb/WriteBackTags',data);
  }




//==============================IOT Console service=======================================//
  getLineMachineData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DynamicDashboard/GetMachineByPlant',data);
  }
  GetIOTTagsDataByMachine(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DynamicDashboard/GetIOTTagsDataByMachine',data);
  }
  
  getAnomalyData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DynamicDashboard/GetAnamaly',data);
  }

  getParameterData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DynamicDashboard/getParameterData',data);
  }

  adselectInput(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DynamicDashboard/saveAnomalyCSV',data);
  }

  adTrainModel(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DynamicDashboard/ADTrainModel',data);
  }

  adInferenceModel(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DynamicDashboard/ADInFerenceModel',data);
  }

  adResultModel(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DynamicDashboard/adResultModel',data);
  }

  getMultivariateParameterData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DynamicDashboard/getMultivariateParameterData',data);
  }

  getModelsList(): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl + 'DynamicDashboard/getModelList');
  }

  deleteModels(data:any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DynamicDashboard/deleteModel',data);
  }

  updateMVModelInfo(data:any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DynamicDashboard/updateMVModelInfo',data);
  }

  updateMVResultInfo(data:any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DynamicDashboard/updateMVResultInfo',data);
  }

  GetMultivariateModelDetail(data:any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DynamicDashboard/GetMultivariateModelDetail',data);
  }
    // ===========================================CRew schedule ==============================//
  
    getCrewSchedule(data:any): Observable<any[]> {
      return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/getCrewScheduleByUnit',data);
    }
}
